import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { JwTokenHandler } from '../shared/services/jw-token-handler.service';
import { UserState } from '../auth/services/user-state.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate {

  constructor(
    private userState: UserState
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const allowedPermissions = route.data?.allowedPermission;
    const userPermissions = this.userState.claims;

    return JwTokenHandler.userHasPermission(userPermissions, allowedPermissions);
  }

}
